import { Debtor } from '@axo/shared/data-access/types';

export const addDebtTypes = (data: Record<string, unknown>) => {
  const result = {};

  const debtKeys = Object.keys(data).filter((key) => key.includes('Debt/'));

  const debtTypes = new Set(debtKeys.map((key) => key.split('/')));

  for (const [key, type] of debtTypes) {
    Object.assign(result, {
      [`${key}/${type}/Type`]: type,
    });

    if (key === 'CoDebt') {
      Object.assign(result, {
        [`${key}/${type}/Debtor`]: Debtor.CoApplicant,
      });
    }
  }

  return result;
};
